import '../vendor';

import './modal-excursion/modal-excursion';
import './modal-excursion/excursion-result';



// WEBPACK FOOTER //
// ./src/js/pages/modal-excursion.js